import { View } from 'react-native';

import type { BlurTargetViewProps } from './BlurView.types';

export default function BlurTargetView(props: BlurTargetViewProps) {
  return <View {...props} />;
}
